import { render, staticRenderFns } from "./couponRecord.vue?vue&type=template&id=70fe76b6&scoped=true"
import script from "./couponRecord.vue?vue&type=script&lang=js"
export * from "./couponRecord.vue?vue&type=script&lang=js"
import style0 from "./couponRecord.vue?vue&type=style&index=0&id=70fe76b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fe76b6",
  null
  
)

export default component.exports